// extracted by mini-css-extract-plugin
export default {"root":"radio-button__root","radio":"radio-button__radio","disabled":"radio-button__disabled","check":"radio-button__check"};